import { HrmRequestFormResponse } from '@Types/api/form';
import { parseDateTime } from '@Utils/transformDateTime';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';

const fieldSource = (
  data: HrmRequestFormResponse,
  resumingFromLabel: string,
  findWorkShiftLabel: (workShift: number) => string
): Array<{ label: string; value: string | number | boolean }> => {
  const { startDate, remarks, ticketRequired, reqStatusId } = data;

  const source = {
    Status: reqStatusId,
    'Resuming From': resumingFromLabel || EMPTY_FIELD_PLACEHOLDER,
    'Resuming On':
      parseDateTime(startDate, 'DD/MM/YYYY') || EMPTY_FIELD_PLACEHOLDER,
    'Work Shift': findWorkShiftLabel(ticketRequired) || EMPTY_FIELD_PLACEHOLDER,
    Remarks: remarks || EMPTY_FIELD_PLACEHOLDER,
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export default fieldSource;
